import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';

const NitroAd = () => {
    const [imgData, setImgData] = useState(null);
    const [merchantData, setMerchantData] = useState(null);

    const {merchantid} = useParams()
    // console.log(merchantData,"merchantDatanitrove")
    
    useEffect(() => {
      setMerchantData(merchantid)
    }, []);


      
      // useEffect(() => {
      //   const storedMerchant = localStorage.getItem('merchantLogin');
      //       if (storedMerchant) {
      //         setMerchantData(JSON.parse(storedMerchant)); // parse string to object
      //       }
      //     }, []);
    
          useEffect(() => {
          if (merchantData) {
            axios
              .get(`https://api.bakpoket.com/api/MerchantPage/GetMerchantStore/${merchantData}`)
              .then((res) => {
                setImgData(res.data);
              })
              .catch((err) => console.log(err));
          }
        }, [merchantData]);
  
        // console.log("imgData1",imgData)
  return (
    // <div className='container'>
    //     {imgData != "" || imgData.landingBanner != null ? <img src={`data:image/jpeg;base64,${imgData?.landingBanner}`} className='img-fluid'/>
    //     :<img src='/puma/category.jpg' className='img-fluid'/>
    //   }
    // </div>
    <div className='container'>
      {imgData && imgData.landingBanner 
        ? <img src={`data:image/jpeg;base64,${imgData.landingBanner}`} className='img-fluid' />
        : <img src='/images/category.jpg' className='img-fluid' />
      }
    </div>

  )
}

export default NitroAd